export default "__VITE_ASSET__BcuW1HEM__"